import { IonLabel } from '@ionic/react';
import { useQuery } from '@apollo/client/react';
import { GET_MY_CHANNELS } from '../../../../graphql/queries/myChannels';
import type { GetMyChannelsQuery } from '../../../../types/graphql-generated';
import { ChannelProfileSection } from './ChannelProfileSection';

export const ChannelProfileList: React.FC = () => {
  const { data } = useQuery<GetMyChannelsQuery>(GET_MY_CHANNELS);

  const channels = data?.myChannels ?? [];
  if (channels.length === 0) {
    return null;
  }

  const heading = channels.length === 1 ? 'Mi canal' : 'Mis canales';

  return (
    <div className="mt-4">
      <IonLabel className="block mb-2 text-sm font-semibold text-gray-500 uppercase tracking-wide">
        {heading}
      </IonLabel>
      <div className="flex flex-col gap-3">
        {channels.map((channel) => (
          <ChannelProfileSection key={channel.id} channel={channel} />
        ))}
      </div>
    </div>
  );
};
